// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-main-tab-content {
  display: flex;
  flex-direction: column;
}
.dl-main-tab-content__table {
  display: table;
  width: 100%;
  table-layout: fixed;
}
.dl-main-tab-content__header {
  display: flex;
  justify-content: space-between;
  height: 48px;
}
.dl-main-tab-content__header_closed {
  border-bottom: 1px solid var(--g-color-line-generic);
}
.dl-main-tab-content__table-header {
  display: table-header-group;
}
.dl-main-tab-content__table-header-cell {
  display: table-cell;
}
.dl-main-tab-content__table-header-cell {
  padding: 0 10px;
  box-sizing: content-box;
}
.dl-main-tab-content__table-header-cell_author {
  width: 165px;
}
.dl-main-tab-content__table-header-cell_date {
  width: 150px;
}
.dl-main-tab-content__table-header-cell_controls {
  width: 100px;
}
.dl-main-tab-content__content {
  margin: auto 0;
}
.dl-main-tab-content__title {
  display: flex;
  font-style: normal;
  font-weight: 500;
  cursor: pointer;
}
.dl-main-tab-content__title-text {
  margin-left: 6px;
}
.dl-main-tab-content__create-btn {
  text-align: right;
}
.dl-main-tab-content__no-objects {
  color: var(--g-color-text-secondary);
  margin-left: 20px;
}
.dl-main-tab-content__show-more-btn {
  width: 100%;
  margin-top: 16px;
}
.dl-main-tab-content__retry-btn {
  margin-top: 16px;
  max-width: 83px;
}
.dl-main-tab-content__error-text {
  font-size: 15px;
  color: var(--g-color-text-danger);
}
.dl-main-tab-content_mobile .dl-main-tab-content__title,
.dl-main-tab-content_mobile .dl-main-tab-content__content-cell {
  font-family: var(--g-text-body-font-family);
  font-weight: var(--g-text-body-font-weight);
  font-size: var(--g-text-body-2-font-size);
  line-height: var(--g-text-body-2-line-height);
}
.dl-main-tab-content_mobile .dl-main-tab-content__title-text {
  font-weight: 500;
}
.dl-main-tab-content_mobile .dl-main-tab-content__title-col {
  padding-right: 8px;
}
.dl-main-tab-content_mobile .dl-main-tab-content__table-header-cell_date {
  width: 60px;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/workbooks/components/Table/WorkbookEntriesTable/MainTabContent/MainTabContent.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;EAGI,aAAA;EACA,sBAAA;AAHJ;AAKI;EACI,cAAA;EACA,WAAA;EACA,mBAAA;AAHR;AAMI;EACI,aAAA;EACA,8BAAA;EACA,YAAA;AAJR;AAOI;EACI,oDAAA;AALR;AAQI;EACI,2BAAA;AANR;AASI;EACI,mBAAA;AAPR;AAUI;EACI,eAAA;EACA,uBAAA;AARR;AAUQ;EACI,YAAA;AARZ;AAWQ;EACI,YAAA;AATZ;AAYQ;EACI,YAAA;AAVZ;AAcI;EACI,cAAA;AAZR;AAeI;EACI,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAbR;AAgBI;EACI,gBAAA;AAdR;AAiBI;EACI,iBAAA;AAfR;AAkBI;EACI,oCAAA;EACA,iBAAA;AAhBR;AAmBI;EACI,WAAA;EACA,gBAAA;AAjBR;AAoBI;EACI,gBAAA;EACA,eAAA;AAlBR;AAqBI;EACI,eAAA;EACA,iCAAA;AAnBR;AAuBQ;;ECqFJ,2CAAA;EACA,2CAAA;EACA,yCAAA;EACA,6CAAA;ADxGJ;AAqBQ;EACI,gBAAA;AAnBZ;AAsBQ;EACI,kBAAA;AApBZ;AAuBQ;EACI,WAAA;AArBZ","sourcesContent":[".dl-main-tab-content {\n  display: flex;\n  flex-direction: column;\n}\n.dl-main-tab-content__table {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n}\n.dl-main-tab-content__header {\n  display: flex;\n  justify-content: space-between;\n  height: 48px;\n}\n.dl-main-tab-content__header_closed {\n  border-bottom: 1px solid var(--g-color-line-generic);\n}\n.dl-main-tab-content__table-header {\n  display: table-header-group;\n}\n.dl-main-tab-content__table-header-cell {\n  display: table-cell;\n}\n.dl-main-tab-content__table-header-cell {\n  padding: 0 10px;\n  box-sizing: content-box;\n}\n.dl-main-tab-content__table-header-cell_author {\n  width: 165px;\n}\n.dl-main-tab-content__table-header-cell_date {\n  width: 150px;\n}\n.dl-main-tab-content__table-header-cell_controls {\n  width: 100px;\n}\n.dl-main-tab-content__content {\n  margin: auto 0;\n}\n.dl-main-tab-content__title {\n  display: flex;\n  font-style: normal;\n  font-weight: 500;\n  cursor: pointer;\n}\n.dl-main-tab-content__title-text {\n  margin-left: 6px;\n}\n.dl-main-tab-content__create-btn {\n  text-align: right;\n}\n.dl-main-tab-content__no-objects {\n  color: var(--g-color-text-secondary);\n  margin-left: 20px;\n}\n.dl-main-tab-content__show-more-btn {\n  width: 100%;\n  margin-top: 16px;\n}\n.dl-main-tab-content__retry-btn {\n  margin-top: 16px;\n  max-width: 83px;\n}\n.dl-main-tab-content__error-text {\n  font-size: 15px;\n  color: var(--g-color-text-danger);\n}\n.dl-main-tab-content_mobile .dl-main-tab-content__title,\n.dl-main-tab-content_mobile .dl-main-tab-content__content-cell {\n  font-family: var(--g-text-body-font-family);\n  font-weight: var(--g-text-body-font-weight);\n  font-size: var(--g-text-body-2-font-size);\n  line-height: var(--g-text-body-2-line-height);\n}\n.dl-main-tab-content_mobile .dl-main-tab-content__title-text {\n  font-weight: 500;\n}\n.dl-main-tab-content_mobile .dl-main-tab-content__title-col {\n  padding-right: 8px;\n}\n.dl-main-tab-content_mobile .dl-main-tab-content__table-header-cell_date {\n  width: 60px;\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
